import React from 'react';
import { Input } from './ui/input';

const COUNTRIES = [
  { code: '+39', country: 'Italy', flag: '🇮🇹', name: 'IT' },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸', name: 'US' },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧', name: 'GB' },
  { code: '+49', country: 'Germany', flag: '🇩🇪', name: 'DE' },
  { code: '+33', country: 'France', flag: '🇫🇷', name: 'FR' },
  { code: '+34', country: 'Spain', flag: '🇪🇸', name: 'ES' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', name: 'PT' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', name: 'NL' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', name: 'BE' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', name: 'CH' },
  { code: '+43', country: 'Austria', flag: '🇦🇹', name: 'AT' },
  { code: '+30', country: 'Greece', flag: '🇬🇷', name: 'GR' },
  { code: '+48', country: 'Poland', flag: '🇵🇱', name: 'PL' },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿', name: 'CZ' },
  { code: '+36', country: 'Hungary', flag: '🇭🇺', name: 'HU' },
  { code: '+40', country: 'Romania', flag: '🇷🇴', name: 'RO' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', name: 'IE' },
  { code: '+358', country: 'Finland', flag: '🇫🇮', name: 'FI' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', name: 'SE' },
  { code: '+47', country: 'Norway', flag: '🇳🇴', name: 'NO' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', name: 'DK' },
  { code: '+61', country: 'Australia', flag: '🇦🇺', name: 'AU' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', name: 'NZ' },
  { code: '+81', country: 'Japan', flag: '🇯🇵', name: 'JP' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', name: 'KR' },
  { code: '+86', country: 'China', flag: '🇨🇳', name: 'CN' },
  { code: '+91', country: 'India', flag: '🇮🇳', name: 'IN' },
  { code: '+971', country: 'UAE', flag: '🇦🇪', name: 'AE' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', name: 'SA' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', name: 'MX' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', name: 'BR' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷', name: 'AR' },
  { code: '+27', country: 'South Africa', flag: '🇿🇦', name: 'ZA' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', name: 'TR' },
  { code: '+7', country: 'Russia', flag: '🇷🇺', name: 'RU' },
];

const PhoneInput = ({ value, onChange, required = false, className = '', testId = 'phone-input' }) => {
  const [countryCode, setCountryCode] = React.useState('+39');
  const [phoneNumber, setPhoneNumber] = React.useState('');

  React.useEffect(() => {
    if (value && value !== `${countryCode} ${phoneNumber}`) {
      const country = COUNTRIES.find(c => value.startsWith(c.code));
      if (country) {
        setCountryCode(country.code);
        setPhoneNumber(value.substring(country.code.length).trim());
      }
    }
  }, [value, countryCode, phoneNumber]);

  React.useEffect(() => {
    const combinedValue = phoneNumber ? `${countryCode} ${phoneNumber}` : '';
    if (onChange && combinedValue !== value) {
      onChange(combinedValue);
    }
  }, [countryCode, phoneNumber, onChange, value]);

  const handleCountryChange = (e) => {
    setCountryCode(e.target.value);
  };

  const handlePhoneChange = (e) => {
    // Allow only numbers, spaces, and hyphens
    const cleaned = e.target.value.replace(/[^\d\s-]/g, '');
    setPhoneNumber(cleaned);
  };

  const selectedCountry = COUNTRIES.find(c => c.code === countryCode);

  return (
    <div className={`flex gap-2 ${className}`}>
      <div className="relative" style={{ width: '140px' }}>
        <select
          value={countryCode}
          onChange={handleCountryChange}
          data-testid={`${testId}-country`}
          className="w-full h-10 bg-white border border-slate-300 rounded-md px-3 py-2 pr-8 text-sm focus:ring-2 focus:ring-blue-900 focus:border-transparent appearance-none cursor-pointer"
          style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
        >
          {COUNTRIES.map((country) => (
            <option key={country.code} value={country.code}>
              {country.flag} {country.code}
            </option>
          ))}
        </select>
        <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
      </div>

      <div className="flex-1">
        <Input
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneChange}
          required={required}
          data-testid={testId}
          placeholder="123 456 7890"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default PhoneInput;
